import './PreferenceToggles.scss';
import { NotificationPreferences } from './NotificationPreferences';
import React from 'react';
import { SalesforcePreferences } from './SalesforcePreferences';
export const PreferenceToggles = () => React.createElement("div", { className: 'preference-toggles' },
    React.createElement(SalesforcePreferences, null),
    React.createElement(NotificationPreferences, null));
